import { FC } from 'react';
import { SummaryStatCard } from 'components/summary-stat-card/summary-stat-card';
import { formatNumber } from 'utils/number';
import type { ProvisioningStatsResponse } from './types';
import styles from './page.module.scss';

interface ProvisioningSummaryCardsProps {
  stats: ProvisioningStatsResponse | undefined;
}

export const ProvisioningSummaryCards: FC<ProvisioningSummaryCardsProps> = ({
  stats,
}) => {
  return (
    <div className={styles.cardsContainer}>
      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Total Batches"
          value={formatNumber(stats?.totalBatches, 0, 0, 'decimal', true, '--')}
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Active"
          value={formatNumber(
            stats?.activeBatches,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
          valueColor="green"
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Docs Processed"
          value={formatNumber(
            stats?.totalDocumentsProcessed,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Docs Failed"
          value={formatNumber(
            stats?.totalDocumentsFailed,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Entities Created"
          value={formatNumber(
            stats?.totalEntitiesCreated,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Locations Created"
          value={formatNumber(
            stats?.totalLocationsCreated,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
        />
      </div>
    </div>
  );
};
